<div class="scroll-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button mat-mini-fab (click)="scrollToTop()" aria-label="scroll to the top">
    <mat-icon>expand_less</mat-icon>
  </button>
</div>
